import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity BuyerUsers


export interface BuyerUser {
    id: ID;

    
    email: string;

    
    name: string;

    
    description?: string;

    
    buyerId: ID;

    
    userId: ID;

    
    scopeGroupId: ID;

    
    buyerUserScopeGroupId: ID;

    }




export interface CreateBuyerUser {
    
    email: string;

    
    name: string;

    
    description?: string;

    
    buyerId: ID;

    
    
    
    }


export interface UpdateBuyerUser {
    
    
    name: string;

    
    description?: string;

    
    
    
    
    }

export interface PresentationBuyerUserRequest {
    list: ListRequest,
    filter: {
        email: string,
        emailOr: boolean,
        name: string,
        nameOr: boolean,
        buyerIdRefs?: ID[],
        userIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryBuyerUser {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: BuyerUser): PrimaryBuyerUser | undefined {
        return entity ? new PrimaryBuyerUser(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryBuyerUser {
        return new PrimaryBuyerUser(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryBuyerUser {
        let vals = path?.split('/');
        return new PrimaryBuyerUser(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryBuyerUser[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: BuyerUser): string {
    let fields = entity ? [
    entity.email,
            entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityBuyerUser {
    id: PrimaryBuyerUser;
    data: UpdateBuyerUser;


    constructor(id: PrimaryBuyerUser, data: UpdateBuyerUser) {
        this.id = id;
        this.data = data;
    }
}
